import React, { useEffect, useState, useRef } from "react";
import { Helmet } from "react-helmet";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import { currencies } from "../../../../../../../static/currencies";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate, useLocation, replace } from "react-router-dom";

function EditOutlet(props) {
  const headers = {
    Authorization: props.user.data.usrKey,
    "Content-Type": "application/json",
    Accept: "application/json",
  };
  const [originalChainObj, setOriginalChainObj] = useState({});
  const [chainObj, setChainObj] = useState({});
  const [groups, setGroups] = useState([]);
  const [brands, setBrands] = useState([]);
  const [levels, setLevels] = useState([]);
  const [selectedLevels, setSelectedLevels] = useState([]); // Track selected levels
  const [isValidChainName, setIsValidChainName] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    getGroups();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (groups.length > 0) {
      getSingleChain();
    }
    // eslint-disable-next-line
  }, [groups]);

  useEffect(() => {
    if (groups.length > 0 && chainObj?.grpKey) {
      const selectedGroup = groups.filter(
        (item) => item.grpKey === chainObj.grpKey
      )[0];
      setBrands(selectedGroup?.brands || []);
      setLevels(selectedGroup?.levels || []);
    }
    // eslint-disable-next-line
  }, [groups, chainObj.grpKey]);

  const firstUpdate_brands = useRef(true);

  useEffect(() => {
    if (brands.length > 0) {
      if (firstUpdate_brands.current) {
        firstUpdate_brands.current = false;
        return;
      }
      setChainObj((prev) => ({ ...prev, braKey: brands[0].braKey }));
    }
    // eslint-disable-next-line
  }, [brands]);

  useEffect(() => {
    if (brands.length > 0 && chainObj.name) {
      validateChainName();
    }
    // eslint-disable-next-line
  }, [chainObj.name, brands]);

  const validateChainName = async () => {
    const selectedName = chainObj?.name?.toLowerCase();
    if (selectedName) {
      const originalChainName = originalChainObj?.brands?.chains?.name;
      const chainsNames =
        brands
          .filter((brandItem) => brandItem.braKey === chainObj?.braKey)[0]
          ?.chains.filter((item) => item.name !== originalChainName)
          .map((chainItem) => chainItem.name.toLowerCase()) || [];
      setIsValidChainName(!chainsNames.includes(selectedName));
    } else {
      setIsValidChainName(false);
    }
  };

  const iconChecker = (type = "default") => {
    if (type === "name") {
      return (
        <div className="mr-3">
          {!chainObj.grpKey ? (
            <FontAwesomeIcon icon="spinner" spin />
          ) : isValidChainName && chainObj?.name ? (
            <FontAwesomeIcon
              className={"icon correct"}
              icon={["fas", "check-circle"]}
            />
          ) : (
            <FontAwesomeIcon
              className={"icon wrong"}
              icon={["fas", "times-circle"]}
            />
          )}
        </div>
      );
    }
    if (type === "level") {
      return (
        <div className="mr-3">
          {selectedLevels.length > 0 ? (
            <FontAwesomeIcon
              className={"icon correct"}
              icon={["fas", "check-circle"]}
            />
          ) : (
            <FontAwesomeIcon
              className={"icon wrong"}
              icon={["fas", "times-circle"]}
            />
          )}
        </div>
      );
    }
    return (
      <div className="mr-3">
        {chainObj?.grpKey ? (
          <FontAwesomeIcon
            className={"icon correct"}
            icon={["fas", "check-circle"]}
          />
        ) : (
          <FontAwesomeIcon icon="spinner" spin />
        )}
      </div>
    );
  };

  const getGroups = async () => {
    try {
      const response = await axios.get(props.chimeraserv.urlGet + "/group", {
        headers,
      });
      setGroups(response.data);
    } catch (error) {
      setGroups([]);
    }
  };

  const getSingleChain = async () => {
    try {
      const response = await axios.get(
        props.chimeraserv.urlGet + "/singleChain/" + props.match.params.id,
        { headers }
      );
      const jsonBody = response.data;
      const selectedChain = jsonBody[0];

      const obj = {
        grpKey: selectedChain?.grpKey,
        braKey: selectedChain?.brands.braKey,
        name: selectedChain?.brands?.chains?.name,
        currency: selectedChain.brands?.chains?.currency || currencies[0],
        outletExp: selectedChain?.brands?.chains?.outletExp
          ? new Date(selectedChain?.brands?.chains?.outletExp * 1000)
          : null,
      };

      setOriginalChainObj(selectedChain);
      setChainObj(obj);

      // Set selected levels from the outlet data
      const outletLevels = selectedChain?.brands?.chains?.levels || [];
      const numericLevels = outletLevels.map((level) =>
        typeof level === "string" ? parseInt(level, 10) : level
      );

      setSelectedLevels(numericLevels);
    } catch (error) {
      setOriginalChainObj({});
      setChainObj({});
      setSelectedLevels([]);
    }
  };

  const handleLevelChange = (levelValue) => {
    const levelId =
      typeof levelValue === "string" ? parseInt(levelValue, 10) : levelValue;
    setSelectedLevels((prev) => {
      if (prev.includes(levelId)) {
        // Remove level if already selected
        return prev.filter((val) => val !== levelId);
      } else {
        // Add level if not selected
        return [...prev, levelId];
      }
    });
  };

  const submitEditing = async (e) => {
    e.preventDefault();

    if (isValidChainName && chainObj?.outletExp && selectedLevels.length > 0) {
      try {
        // Convert selected level IDs to level objects
        // const levelsToSend = levels.filter((level) =>
        //   selectedLevels.includes(level.id)
        // );

        const body = {
          grpKey: chainObj?.grpKey,
          currency: chainObj?.currency,
          name: chainObj?.name,
          outletExp: chainObj?.outletExp,
          levels: selectedLevels, // Include selected levels
        };

        await axios.put(
          props.chimeraserv.urlGet + "/singleChain/" + props.match.params.id,
          body,
          { headers }
        );
        alert("Successfully updated");
        await getSingleChain();
      } catch (error) {
        alert("Failed to update outlet");
      }
    } else {
      if (!isValidChainName) {
        alert("This name was already chosen by another outlet");
      } else if (selectedLevels.length === 0) {
        alert("Please select at least one level");
      } else {
        alert("Invalid expiration date value");
      }
    }
  };

  return (
    <div className={"custForm"}>
      <Helmet>
        <title>Edit Outlet | Chimera Solutions | Insights</title>
      </Helmet>

      <div className={["viewTitle"]}>Edit an Outlet</div>
      <form onSubmit={submitEditing} className={["form"]}>
        <div className={["form-group align-items-center"]}>
          <label htmlFor="group">
            Group <span>*</span>
          </label>
          {iconChecker()}

          <select
            required
            disabled
            className="form-control"
            id="group"
            onChange={(event) => {
              setChainObj({
                ...chainObj,
                grpKey: event.target.value,
              });
            }}
            value={chainObj.grpKey || ""}
          >
            {groups.map((data, key) => (
              <option value={data.grpKey} key={key}>
                {data.name}
              </option>
            ))}
          </select>
        </div>

        <div className={"form-group align-items-center"}>
          <label htmlFor="brand">
            Brand <span>*</span>
          </label>
          {iconChecker()}
          <select
            disabled
            required
            className="form-control"
            id="brand"
            onChange={(event) => {
              setChainObj({
                ...chainObj,
                braKey: event.target.value,
              });
            }}
            value={chainObj.braKey || ""}
          >
            {brands.map((data, key) => {
              return (
                <option value={data.braKey} key={key}>
                  {data.name}
                </option>
              );
            })}
          </select>
        </div>

        {/* Levels Selection */}
        <div className={"form-group"}>
          <label>
            Levels <span>*</span>
          </label>
          {iconChecker("level")}
          <div className="levels-container">
            {levels.length > 0 ? (
              levels.map((level, key) => (
                <div key={key} className="level-checkbox">
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      checked={selectedLevels.includes(parseInt(level.id, 10))}
                      onChange={() => handleLevelChange(level.id)}
                    />
                    <span className="checkmark"></span>
                    {level.name} (Level {level.id})
                  </label>
                </div>
              ))
            ) : (
              <div className="no-levels">
                {chainObj.grpKey
                  ? "No levels available for this group"
                  : "Select a group first"}
              </div>
            )}
          </div>
        </div>

        <div className={"form-group align-items-center"}>
          <label>
            Outlet Name <span>*</span>
          </label>
          {iconChecker("name")}
          <div className={["field"]}>
            <input
              required
              type={"text"}
              className={["form-control"]}
              id={"name"}
              minLength={4}
              placeholder={"enter outlet name"}
              value={chainObj?.name || ""}
              onChange={(e) =>
                setChainObj({ ...chainObj, name: e.target.value })
              }
            />
          </div>
        </div>

        <div className={"form-group align-items-center"}>
          <label htmlFor="currency">
            Currency <span>*</span>
          </label>
          {iconChecker()}
          <select
            required
            className="form-control"
            id="currency"
            onChange={(e) =>
              setChainObj({ ...chainObj, currency: e.target.value })
            }
            value={chainObj.currency || currencies[0]}
          >
            {currencies.map((item, key) => (
              <option key={key} value={item}>
                {item}
              </option>
            ))}
          </select>
        </div>

        <div className={["form-group"]}>
          <label>
            Outlet Expiration <span>*</span>
          </label>
          {iconChecker()}
          <div className={["date"].join(" ")}>
            <DatePicker
              className={["form-control"]}
              placeholderText="MM-DD-YY"
              selected={chainObj.outletExp ? chainObj.outletExp : null}
              onSelect={async (date) =>
                setChainObj({ ...chainObj, outletExp: new Date(date) })
              }
              onChange={async (date) =>
                setChainObj({ ...chainObj, outletExp: new Date(date) })
              }
              // minDate={new Date()}
            />
          </div>
        </div>

        <button
          type={"submit"}
          className={["btn btn-primary"]}
          disabled={!isValidChainName || selectedLevels.length === 0}
        >
          Save
        </button>
        <button
          type={"button"}
          onClick={() => getSingleChain()}
          className={["btn btn-primary", "reset"].join(" ")}
        >
          Reset
        </button>
      </form>
    </div>
  );
}

export default EditOutlet;
